import nhost from './nhost';

export const POINTS = {
  rate_wine: 5,
  comment_wine: 2,
  session_comment: 3,
  upload_photo: 5,
  wine_interest: 1,
  profile_avatar: 10,
  profile_phone: 5,
  host_session: 20,
  attend_session: 10,
  winebox_rsvp: 3,
};

export async function awardPoints(userId, activity, referenceId = null, points = null) {
  const p = points ?? POINTS[activity];
  if (!p) return;
  try {
    const result = await nhost.graphql.request(`
      mutation AwardPoints($obj: user_points_insert_input!) {
        insert_user_points_one(
          object: $obj,
          on_conflict: { constraint: user_points_user_id_activity_reference_id_key, update_columns: [] }
        ) { id }
      }
    `, {
      obj: {
        user_id: userId,
        activity,
        points: p,
        reference_id: referenceId,
      }
    });

    // Only check leaderboard if points were actually inserted (not a duplicate)
    if (result.data?.insert_user_points_one?.id) {
      checkLeaderboardChange(userId, p).catch(() => {});
    }
  } catch {}
}

async function checkLeaderboardChange(userId, awarded) {
  const { data } = await nhost.graphql.request(`
    query {
      user_points { user_id points }
      profiles(where: { approved: { _eq: true } }) { id display_name }
    }
  `);
  if (!data?.user_points) return;

  // Sum points per user
  const totals = {};
  data.user_points.forEach(r => {
    totals[r.user_id] = (totals[r.user_id] || 0) + r.points;
  });

  const nameMap = {};
  data.profiles.forEach(p => { nameMap[p.id] = p.display_name; });

  // Calculate current rank
  const ranked = Object.entries(totals).sort((a, b) => b[1] - a[1]);
  const newRank = ranked.findIndex(([id]) => id === userId) + 1;
  if (newRank === 0) return;

  // Simulate rank before this award by subtracting the awarded points
  const prevTotals = { ...totals, [userId]: totals[userId] - awarded };
  const prevRanked = Object.entries(prevTotals).sort((a, b) => b[1] - a[1]);
  const prevRank = prevRanked.findIndex(([id]) => id === userId) + 1;

  // Only notify if position improved
  if (newRank >= prevRank) return;

  const rankText = newRank === 1 ? 'topplistan' : `plats ${newRank}`;
  const displayName = nameMap[userId] || 'Någon';

  await fetch('/api/push?action=send', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      title: `${displayName} klättrade på topplistan!`,
      body: `${displayName} gick från plats ${prevRank} till ${rankText} med ${totals[userId]} poäng!`,
      url: '/',
    }),
  }).catch(() => {});
}
